module.exports = __webpack_public_path__ + "img/2022.aac68e15.svg";